import axios from 'axios';
import { Notification, MessageBox, Message, Loading } from 'element-ui'
import { tansParams } from "@/utils/utils";
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 对应国际化资源文件后缀
axios.defaults.headers['Content-Language'] = 'zh_CN'
import router from "@/router/index"
export let isRelogin = { show: false };


// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分 
  baseURL: '/api',
  // 超时
  timeout: 100000
})


// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?' + tansParams(config.params);
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    // const token = localStorage.getItem('agri_token');
    // if (token) {
    //   config.headers['Authorization'] = token;
    // }
    // 在发送请求之前做些什么
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return res;
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 未设置状态码则默认成功状态
    const code = res.code || 200;
    if (code != 401) {
      isRelogin.show = false;
    }
    // 获取错误信息
    if (code === 401) {
      // if (!isRelogin.show) {
      //   isRelogin.show = true;
      //   Message({
      //     message: '登录过期，请重新登陆',
      //     type: 'error',
      //     duration: 1000
      //   });
      //   router.replace('/login');
      // }
      return res
    } else if (code === 500) {
      // Message({
      //   message: res.msg,
      //   type: 'error'
      // })
      return res
    } else if (code !== 200) {
      Notification.error({
        title: res.msg
      })
      return res
    } else {
      return res
    }
  },
  (error) => {
    // Message({
    //   message: error.message,
    //   type: 'error'
    // })
  }
);


export default service;





